import React from "react";
import { Link } from "react-router-dom";

const Overview = ({category, type, selectedModule}) => {
  if (selectedModule === "bs") {
    return (
        <div className="mt-3">
          <p>This feature is not available for Bench Sales. However, you can configure the following features:</p>
          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Available Features for Bench Sales:</h6>
            <p>1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt; Kult AI (Text) &gt; Setup / Configure</p>
            <p>2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt; Apollo &gt; Setup / Configure</p>
            <p>3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt; G-Suite &gt; Setup / Configure</p>
            <p>4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt; Outlook &gt; Setup / Configure</p>
          </div>
        </div>
      );
  }
  return (
    <div className="border border-gray-200 rounded-md shadow-sm p-4 mt-8 bg-white">
      <h2 className="text-lg font-semibold text-orange-600 mb-2">Details</h2>

      <div className="overflow-y-auto pr-12">
        <p className="text-sm text-gray-700 mb-4">
          Zoom is a video teleconferencing software developed by Zoom Video
          Communications. With Zoom you can increase cross team collaborations
          easily by connecting and communicating with internal teams and
          external parties at ease. Oorwin’s Zoom integration will help you
          connect with your clients either through audio/video calls.
        </p>

        <h3 className="text-xl text-gray-800 mb-4">Steps to Connect</h3>
        <ol className="list-decimal list-inside text-sm text-gray-700 space-y-5">
          <li>
            Sign in to your Zoom account from{" "}
            <Link
              to="https://marketplace.zoom.us"
              className="text-blue-600 underline"
            >
              https://marketplace.zoom.us
            </Link>
            .
          </li>
          <li>
            On the top right, select <b>"Develop"</b> and click on{" "}
            <b>"Build app"</b>.
          </li>
          <li>
            Under "Choose your app type" section select <b>"Server-to-server</b>{" "}
            OAuth" by clicking "Create" button.
          </li>
          <li>
            If a popup appears asking to agree to{" "}
            <b>Zoom’s API License and Terms of Use</b>, click on "Agree".
          </li>
          <li>
            A pop appears asking for App name, Key in your company name and
            click on <b>"Create"</b> (Name doesn't affect the functionality).
          </li>
          <li>You will be redirected to Zoom Marketplace page.</li>
          <li>
            You will be seeing "Account Id" "API Key" and "API Secret Key"
            information, copy them for future use and click on <b>"Continue"</b>
          </li>
          <li>
            Fill the details in Company name, Name, and Email address fields and
            click
            <b>"Continue"</b> (Name and Email Address will be used by Zoom to
            communicate any issue).
          </li>
          <li>
            Now you will be in the Feature section. Click <b>"Continue"</b>.
          </li>
          <li>
            In the Scopes tab, add the meeting scopes of{" "}
            <b>
              View all users meetings (<code>meeting:read:admin</code>)
            </b>
            and{" "}
            <b>
              "View and manage all user meetings (
              <code>meeting:write:admin</code>)"
            </b>{" "}
            (These 2 states are mandatory for scheduling the meetings) Now click{" "}
            <b>"Continue"</b>
          </li>
          <li>
            Click on "Continue" in the activation page which activates your
            account for integration.
          </li>
          <li>
            Now Login to your Oorwin account and go to{" "}
            <b>
              Marketplace → Video Interviews → Zoom → Configure → Add Account
            </b>
            .
          </li>
          <li>
            Key in the Display name, Account ID, API Key, API Secret Key &
            Status and click on <b>"Save"</b>.
          </li>
          <li>A Zoom account will be added in the app.</li>
          <li>
            Add/Map users to the created account for them to access Zoom
            interviews while scheduling.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Overview;
